//material
<template>
  <div class="link-views white-bg">
    <div class="top">
      <Button type="primary" @click="addItemFn('editItem')">添加</Button>
    </div>
    <div class="select-div">
      <div class="mr">
        <span>关键字查询：</span>
        <Input clearable v-model="keyword" style="width:200px"/>
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="sureSearch(keyword)">查询</Button>
        <Button type="primary" icon="md-refresh" @click="sureSearch('')">重置</Button>
      </div>
    </div>
    <div class="list">
      <Row :gutter="16" v-if="ConsumablesList.Result.length>0">
        <i-col
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="6"
          :xxl="4"
          v-for="(item,index) in ConsumablesList.Result"
          :key="index"
          class="listItem"
        >
          <Card>
            <div class="imgBox imgBox1">
              <img :src="port+item.ImgUrl">
              <a class="star">
                <div @click="editItemFn(item)">
                  <Icon type="md-create"/>
                </div>
                <div @click="delItemFn(item)">
                  <Icon type="ios-trash-outline"/>
                </div>
              </a>
            </div>
            <div class="cardText">
              <Tooltip :content="item.ConsumablesName" placement="top">
                <div class="text-overflow">{{item.ConsumablesName}}</div>
              </Tooltip>
              <Tooltip :content="item.ConsumablesNo" placement="top">
                <div class="text-overflow">耗材编号：{{item.ConsumablesNo}}</div>
              </Tooltip>
            </div>
          </Card>
        </i-col>
      </Row>
      <div v-else class="nodata">暂无数据</div>
    </div>
    <div class="page-div">
      <Page
        show-total
        :total="ConsumablesList.records"
        :current="page"
        :page-size="size"
        @on-change="changePage"
      />
    </div>
    <!-- 全局模态框 -->
    <Modal
      v-model="showfullscreen"
      fullscreen
      title="编辑"
      :class="{'myfullscreen':true,'noLeft':isCollapsed }"
      :mask-closable="false"
      @on-ok="sureEdit('editItem')"
    >
      <Form ref="editItem" :model="editItem" :label-width="100" :rules="ruleValidate">
        <FormItem label="图片" prop="ImgUrl">
           <myUpload
            v-if="showfullscreen"
            :defaultList="ImageUrlList"
            :isImg="'img'"
            @getUrlList="(val)=>getUrlArr(val,'ImgUrl')"
          ></myUpload>
        </FormItem>
        <FormItem label="耗材名称：" prop="ConsumablesName">
          <Input clearable v-model="editItem.ConsumablesName" style="width:200px"/>
        </FormItem>
        <FormItem label="耗材型号：" prop="ModelNumber">
          <Input clearable v-model="editItem.ModelNumber" style="width:200px"/>
        </FormItem>
        <FormItem label="耗材编号：" prop="ConsumablesNo">
          <Input clearable v-model="editItem.ConsumablesNo" style="width:200px"/>
        </FormItem>
        <FormItem label="耗材价格：" prop="Price">
          <InputNumber :min="0" clearable v-model="editItem.Price" style="width:200px"></InputNumber>
        </FormItem>
        <FormItem label="负责人：" prop="Person">
          <Input clearable v-model="editItem.Person" style="width:200px;margin-right:20px;"/>
        </FormItem>
        <FormItem label="联系方式：" prop="PerTelPhone">
          <Input clearable v-model="editItem.PerTelPhone" style="width:200px"/>
        </FormItem>
        <FormItem label="所在位置：" prop="RoomId">
          <i-select v-model="editItem.RoomId" style="width:200px" placement="top">
            <i-option
              v-for="item in RoomList"
              :value="item.RoomId"
              :key="item.RoomId"
            >{{ item.RoomName }}</i-option>
          </i-select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showfullscreen=false">取消</Button>
        <Button type="primary" @click="sureEdit('editItem')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import * as allFn from "../../../utils/index.js";
import myUpload from "../../../components/my-upload";
export default {
  name: "material",
   components: {
    myUpload: myUpload
  },
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      loading: true,
      ConsumablesList: { Result: [] },
      showfullscreen: false,
      editItem: {
        Price:0,
      },
      size: 12,
      page: 1,
      ruleValidate: {
        ImgUrl: [
          { required: true, message: "耗材图片不能为空", trigger: "blur" }
        ],
        ConsumablesName: [
          { required: true, message: "耗材名称不能为空", trigger: "blur" }
        ],
        ModelNumber: [
          { required: true, message: "耗材型号不能为空", trigger: "blur" }
        ],
        ConsumablesNo: [
          { required: true, message: "耗材编号不能为空", trigger: "blur" }
        ],
        Price: [
          {
            required: true,
            type: "number",
            message: "耗材价格不能为空",
            trigger: "change"
          }
        ],
        Person: [
          { required: true, message: "负责人不能为空", trigger: "blur" }
        ],
        PerTelPhone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            validator: allFn.validatePhoto,
            trigger: "change"
          }
        ],
        RoomId: [
          {
            required: true,
            type: "number",
            message: "所在位置不能为空",
            trigger: "change"
          }
        ]
      },
      RoomList: [],
      keyword: "",
      ImageUrlList:[]
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    }
  },
  mounted() {
    this.getRoomList();
    this.getpageArr();
  },
  watch: {},
  methods: {
    //获取所有实验室
    async getRoomList() {
      this.RoomList = await homeApi.GetRoomArr({
        BuildId: 0,
        FloorId: 0
      });
    },
    // 获取分页数据
    async getpageArr() {
      this.ConsumablesList = await homeApi.GetConsumablesList({
        keyword: this.keyword ? this.keyword : "",
        page: this.page ? this.page : 1,
        size: this.size ? this.size : 12
      });
      this.loading = false;
    },

    //添加
    addItemFn(name) {
      this.$refs["editItem"].resetFields();
      this.editApi = "AddConsumables";
      this.editItem = {
        Price:0,
      };
      this.keyword = "";
      this.page = 1;
      this.ImageUrlList=[];
        this.showfullscreen = true;
    },
    //编辑
    editItemFn(row) {
      this.$refs["editItem"].resetFields();
      homeApi
        .GetConsumablesById({
          ConsumablesId: row.ConsumablesId
        })
        .then(res => {
          this.editApi = "AmendConsumables";
          this.editItem = res;
          this.ImageUrlList = [{ url: res.ImgUrl }];
          this.showfullscreen = true;
        });
    },
    // 确认编辑
    sureEdit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          homeApi[this.editApi](this.editItem).then(res => {
            if (res.success) {
              this.getpageArr();
              this.showfullscreen = false;
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3
          });
        }
      });
    },
    //删除
    delItemFn(row) {
      this.$Modal.confirm({
        title: "删除耗材",
        content: "确认删除" + row.ConsumablesName,
        onOk: () => {
          homeApi
            .delConsumables({ ConsumablesId: row.ConsumablesId })
            .then(res => {
              if (res.success) {
                this.keyword = "";
                this.page = 1;
                this.getpageArr();
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 3
                });
              }
            });
        }
      });
    },
    // 搜索
    sureSearch(keyword) {
      this.keyword = keyword;
      this.page = 1;
      this.getpageArr();
    },
    // 分页
    changePage(page) {
      // this.keyword = "";
      this.page = page;
      this.getpageArr();
    },
     getUrlArr(val, str) {
      // this.editItem[str] = val[val.length - 1].url;
      this.$set(this.editItem, str, val[val.length - 1].url);
    }
  }
};
</script>

<style scoped>
</style>